import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { Moment } from '@e3dc-react/shell/Libs/moment'

import { ChartView } from 'src/Libs/chart-kit'
import { WeightedPricesModel } from 'src/Libs/dynamic-power-prices/api/dto/weighted-prices.dto'
import { getWeightedPrices } from 'src/Libs/dynamic-power-prices/api/tariffs.api'
import { useTypedSelector } from 'src/State/RootReducer'
import { usePortalQuery } from 'src/Libs/api'

type UseWeightedPrices = {
  weightedPrices?: WeightedPricesModel
  isLoading: boolean
  isError: boolean
}
/**
 * Custom hook to fetch weighted prices
 */
const useWeightedPrices = ({ from, to, view, isEnabled }: { from: Moment; to: Moment; view: ChartView; isEnabled?: boolean }): UseWeightedPrices => {
  const authFetch = useAuthFetchWithResult()
  const installationId = useTypedSelector(state => state.storage.activeInstallation)?.toString() ?? ''

  const resolution = getWeightedPriceResolutionFromView(view)

  const {
    data: weightedPrices,
    isLoading,
    isError,
  } = usePortalQuery({
    queryKey: ['weighted-prices', installationId, resolution, from, to],
    queryFn: () => getWeightedPrices(authFetch, installationId, from.valueOf(), to.valueOf(), resolution),
    enabled: isEnabled && Boolean(installationId),
  })

  return { weightedPrices: weightedPrices ?? undefined, isLoading, isError }
}

export default useWeightedPrices

const getWeightedPriceResolutionFromView = (view: ChartView): 'quarter' | 'hour' | 'day' | 'month' => {
  switch (view) {
    case 'day':
      return 'quarter'
    case 'week':
      return 'hour'
    case 'month':
      return 'day'
    case 'year':
      return 'month'
    default:
      return 'quarter'
  }
}
